export default __webpack_public_path__ + "static/media/logo-workday.1705a07e.svg";